exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legend[data-v-dadda248] {\n  position: absolute;\n  bottom: 30px;\n  right: 20px;\n}\n.bar-item[data-v-dadda248] {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.bar-item .label[data-v-dadda248] {\n  margin-right: .75rem;\n  text-align: right;\n  font-weight: bold;\n}\n.bar-item .percentage[data-v-dadda248] {\n  min-width: 65px !important;\n  text-align: left;\n  font-weight: bold;\n}\n.bar-item .bar[data-v-dadda248] {\n  width: 70%;\n}\n.bar-item .bar .text-data[data-v-dadda248] {\n  color: grey;\n  word-wrap: normal;\n  flex-shrink: 0;\n}\n", ""]);

// exports
